import Vue from 'vue'
import VeeValidate from 'vee-validate'
import VueScrollTo from 'vue-scrollto'
import VueClipboards from 'vue-clipboards'

import Registration from '../components/Registration.vue'
import Application from '../components/Application.vue'
import UserContentEditor from '../components/UserContentEditor.vue'
import RequestPassword from '../components/RequestPassword.vue'
import ChangePassword from '../components/ChangePassword.vue'
import UserContentAdministration from '../components/UserContentAdministration.vue'
import UserContentEditPanel from '../components/UserContentEditPanel.vue'
import UserContentLibLoader from '../components/UserContentLibLoader.vue'
import ProfileAvatarEditor from '../components/ProfileAvatarEditor.vue'
import ProfileAvatar from '../components/ProfileAvatar.vue'
import ProfileSmallAvatar from '../components/ProfileSmallAvatar.vue'
import ProfileBanner from '../components/ProfileBanner.vue'
import ProfileInfo from '../components/ProfileInfo.vue'
import ProfileUsername from '../components/ProfileUsername.vue'
import ProfilePlatform from '../components/ProfilePlatform.vue'
import ProfileBannerEditor from '../components/ProfileBannerEditor.vue'
import ProfileSurveyEditor from '../components/ProfileSurveyEditor.vue'
import ProfileCompletion from '../components/ProfileCompletion.vue'
import Survey from '../components/Survey.vue'
import ProfileInvitation from '../components/ProfileInvitation.vue'
import ProfileDeleter from '../components/ProfileDeleter.vue'
import SmallProfileNavigation from '../components/SmallProfileNavigation.vue'
import MyFinishedProjectsList from '../components/MyFinishedProjectsList.vue'
import Countdown from '../components/Countdown.vue'
import TeaserCountdown from '../components/TeaserCountdown.vue'

import helper from './article-helper.js'

const EventBus = new Vue()

Object.defineProperties(Vue.prototype, {
  $bus: {
    get: function () {
      return EventBus
    }
  }
});


export default function() {
	Vue.use(VeeValidate);
	Vue.use(VueScrollTo, {
		container: "body",
		duration: 500,
		easing: "ease",
		offset: -100,
		cancelable: true,
		onDone: false,
		onCancel: false,
		x: false,
		y: true
	});
	Vue.use(VueClipboards);
	Vue.filter('striphtml', function (value) {
		var div = document.createElement("div");
		div.innerHTML = value;
		var text = div.textContent || div.innerText || "";
		return text;
	});	  
	if($("#registrationElements").length) {
		
		var vueinst = new Vue({
			el: "#registrationElements",
			data: {
				questionnaire: {},
				selectChoices: {},
			},
			created: function() {
				this.getElements(this);
			},
			render: function(createElement) {
				return createElement(Registration, {
				props: {
					questionnaire: this.questionnaire,
					recaptchaSiteKey: $("#registrationElements").attr('recaptchaSiteKey'),
					crew: $("#registrationElements").attr('crew')?$("#registrationElements").attr('crew'):null
				}})},
			mixins: [ helper ],
			methods: {
				initAnswers: function(item, index) {
					if(item.propertyInfo.type.kind == 'ADDRESS') {
						item.answer = {questionId: item.id, value: {}, type: "ADDRESS", visible: true};
					}else if(item.propertyInfo.type.kind == 'MULTICHOICE') {
						item.answer = {questionId: item.id, value: [], type: "LIST", visible: true};
					}else if(item.propertyInfo.type.kind == 'MATRIX') {
						item.answer = {questionId: item.id, value: {}, type: "MATRIX", visible: true};
					}else if(item.propertyInfo.type == 'BOOLEAN') {
						item.answer = {questionId: item.id, type: "BOOLEAN", visible: true};
					}else {
						item.answer = {questionId: item.id, type: "STRING", visible: true};
					}
				},
				getElements: function(caller) {
					jQuery.ajax ({
						url: '/getRegistrationQuestionnaire',
						type: 'POST',
						dataType: "json",
						data: "",
					    contentType: "application/json; charset=utf-8",
						success: function(data) {
							var result = data;
							result.questionList.forEach(caller.initAnswers);
							caller.questionnaire = result;
							caller.$children[0].onElementsLoaded();
						},
						error: function() {alert("error");}
					});
				}
			}
		});
	}else if($("#applicationElements").length) {
		
		var vueinst = new Vue({
			el: "#applicationElements",
			data: {
				application: {},
				selectChoices: {},
				projectName: {shortname: ""},
				prefill: {},
				applicationLoaded: false,
				prefillLoaded: false
			},
			created: function() {
				this.getProjectName();
				this.getElements(this);
				this.getPrefill(this);
			},
			render: function(createElement) {
				return createElement(Application, {
				props: {
					application: this.application
				}})},
			mixins: [ helper ],
			methods: {
				initAnswers: function(item, index) {
					if(item.propertyInfo.type.kind == 'ADDRESS') {
						item.answer = {questionId: item.id, value: {}, type: "ADDRESS", visible: true};
					}else if(item.propertyInfo.type.kind == 'MULTICHOICE') {
						item.answer = {questionId: item.id, value: [], type: "LIST", visible: true};
					}else if(item.propertyInfo.type.kind == 'MATRIX') {
						item.answer = {questionId: item.id, value: {}, type: "MATRIX", visible: true};
					}else if(item.propertyInfo.type == 'BOOLEAN') {
						item.answer = {questionId: item.id, type: "BOOLEAN", visible: true};
					}else {
						item.answer = {questionId: item.id, type: "STRING", visible: true};
					}
				},
				initPrefill: function() {
					if(!this.prefillLoaded || !this.applicationLoaded) {
						return;
					}
					var inst = this;
					this.application.questionnaire.questionList.forEach(function(item, index) {
						if(inst.prefill.hasOwnProperty(item.propertyInfo.key.value)) {
							if(item.propertyInfo.type.kind == 'ADDRESS') {
								var address = inst.prefill[item.propertyInfo.key.value];
								if(address.city) {
									item.answer.value.city = address.city.value;
								}
								if(address.street) {
									item.answer.value.street = address.street.value;
								}
								if(address.number) {
									item.answer.value.number = address.number.value;
								}
								if(address.firstName) {
									item.answer.value.firstname = address.firstName.value;
								}
								if(address.lastName) {
									item.answer.value.lastname = address.lastName.value;
								}
								if(address.zip) {
									item.answer.value.zip = address.zip.value;
								}
								if(address.country) {
									item.answer.value.country = address.country.value;
								}
							}else if(item.propertyInfo.type.kind == 'MULTICHOICE') {
								item.answer.value = inst.prefill[item.propertyInfo.key.value].choices;
							}else if(item.propertyInfo.type.kind == 'MATRIX' || item.propertyInfo.type == 'BOOLEAN') {
								//do nothing for now
							}else {
								item.answer.value = inst.prefill[item.propertyInfo.key.value].value;
							}
						}
					});
					this.$children[0].onElementsLoaded();
				},
				getElements: function(caller) {
					jQuery.ajax ({
						url: '/getApplicationQuestionnaire',
						type: 'GET',
						data: {
							projectName: this.projectName.shortname
						},
					    contentType: "application/json; charset=utf-8",
						success: function(data) {
							var result = data;
							result.questionnaire.questionList.forEach(caller.initAnswers);
							caller.application = result;
							caller.applicationLoaded = true;
							caller.initPrefill();
						},
						error: function() {console.log("error while loading application questionnaire");}
					});
				},
				getPrefill: function(caller) {
					jQuery.ajax ({
						url: '/getPrefillValuesForApplication',
						type: 'GET',
						data: {
							projectName: this.projectName.shortname
						},
					    contentType: "application/json; charset=utf-8",
						success: function(data) {
							caller.prefill = data;
							caller.prefillLoaded = true;
							caller.initPrefill();
						},
						error: function() {console.log("error while loading prefilled answers");}
					});
				},
				getProjectName: function() {
	                var url = window.location.href;
	                var pattern = new RegExp('(?:https?://)?[^/]*/project/([^/]*)/application\.html', 'i');
	                if(pattern.test(url)) {
	                    this.projectName.shortname = url.match(pattern)[1];
	                }
	            }
			}
		});
	}else if($("#questionnaireElements").length) {
		
		var vueinst = new Vue({
			el: "#questionnaireElements",
			data: {
				survey: {},
				selectChoices: {},
				projectName: {shortname: ""},
				surveyName: {shortname: ""},
				prefill: {},
				surveyLoaded: false,
				prefillLoaded: false
			},
			created: function() {
				this.getProjectName();
				this.getElements(this);
				this.getPrefill(this);
			},
			render: function(createElement) {
				return createElement(Survey, {
				props: {
					survey: this.survey
				}})},
			mixins: [ helper ],
			methods: {
				initAnswers: function(item, index) {
					if(item.propertyInfo.type.kind == 'ADDRESS') {
						item.answer = {questionId: item.id, value: {}, type: "ADDRESS", visible: true};
					}else if(item.propertyInfo.type.kind == 'MULTICHOICE') {
						item.answer = {questionId: item.id, value: [], type: "LIST", visible: true};
					}else if(item.propertyInfo.type.kind == 'MATRIX') {
						item.answer = {questionId: item.id, value: {}, type: "MATRIX", visible: true};
					}else if(item.propertyInfo.type == 'BOOLEAN') {
						item.answer = {questionId: item.id, type: "BOOLEAN", visible: true};
					}else {
						item.answer = {questionId: item.id, type: "STRING", visible: true};
					}
				},
				initPrefill: function() {
					if(!this.prefillLoaded || !this.surveyLoaded) {
						return;
					}
					var inst = this;
					this.survey.questionnaire.questionList.forEach(function(item, index) {
						if(inst.prefill.hasOwnProperty(item.propertyInfo.key.value)) {
							if(item.propertyInfo.type.kind == 'ADDRESS') {
								var address = inst.prefill[item.propertyInfo.key.value];
								if(address.city) {
									item.answer.value.city = address.city.value;
								}
								if(address.street) {
									item.answer.value.street = address.street.value;
								}
								if(address.number) {
									item.answer.value.number = address.number.value;
								}
								if(address.firstName) {
									item.answer.value.firstname = address.firstName.value;
								}
								if(address.lastName) {
									item.answer.value.lastname = address.lastName.value;
								}
								if(address.zip) {
									item.answer.value.zip = address.zip.value;
								}
								if(address.country) {
									item.answer.value.country = address.country.value;
								}
							}else if(item.propertyInfo.type.kind == 'MULTICHOICE') {
								item.answer.value = inst.prefill[item.propertyInfo.key.value].choices;
							}else if(item.propertyInfo.type.kind == 'MATRIX' || item.propertyInfo.type == 'BOOLEAN') {
								//do nothing for now
							}else {
								item.answer.value = inst.prefill[item.propertyInfo.key.value].value;
							}
						}
					});
					this.$children[0].onElementsLoaded();
				},
				getElements: function(caller) {
					jQuery.ajax ({
						url: '/getSurveyQuestionnaire',
						type: 'GET',
						data: {
							projectName: this.projectName.shortname,
							surveyName: this.surveyName.shortname
						},
					    contentType: "application/json; charset=utf-8",
						success: function(data) {
							var result = data;
							result.questionnaire.questionList.forEach(caller.initAnswers);
							caller.survey = result;
							caller.surveyLoaded = true;
							caller.initPrefill();
						},
						error: function() {console.log("error while loading survey questionnaire");}
					});
				},
				getPrefill: function(caller) {
					jQuery.ajax ({
						url: '/getPrefillValuesForSurvey',
						type: 'GET',
						data: {
							projectName: this.projectName.shortname,
							surveyName: this.surveyName.shortname
						},
					    contentType: "application/json; charset=utf-8",
						success: function(data) {
							caller.prefill = data;
							caller.prefillLoaded = true;
							caller.initPrefill();
						},
						error: function() {console.log("error while loading prefilled answers");}
					});
				},
				getProjectName: function() {
	                var url = window.location.href;
	                var pattern = new RegExp('(?:https?://)?[^/]*/project/([^/]*)/survey/([^/]*)/show\.html', 'i');
	                if(pattern.test(url)) {
	                    this.projectName.shortname = url.match(pattern)[1];
	                    this.surveyName.shortname = url.match(pattern)[2];
	                }
	            }
			}
		});
	}
	else if($("#requestPassword").length) {
		var vueinst = new Vue({
			el: "#requestPassword",
			render: function(createElement) {
				return createElement(RequestPassword, {
				props: {
					recaptchaSiteKey: $("#requestPassword").attr('recaptchaSiteKey')
				}})},
		});
	}
	else if($("#changePassword").length) {
		var vueinst = new Vue({
			el: "#changePassword",
			render: function(createElement) {
				return createElement(ChangePassword, {
				props: {
					hash: $("#changePassword").attr('hash'),
					recaptchaSiteKey: $("#changePassword").attr('recaptchaSiteKey'),
				}})},
		});
	}
	if($("#userContentAdministration").length) {
		var project = $("#userContentAdministration").attr("data-project");
		var vueinst = new Vue({
			el: "#userContentAdministration",
			render: function(createElement) {
				return createElement(UserContentAdministration, {
				props: {
					project: project
				}
			})},
		});
	}
	if($("#userContentEditor").length) {
		var project = $("#userContentEditor").attr("data-project");
		var tabs = $("#userContentEditor").attr("data-tabs").split(",");
		var key = $("#userContentEditor").attr("data-key");
		if (key === undefined) {
			key = null;
		}
		var replykey = $("#userContentEditor").attr("data-replykey");
		if (replykey === undefined) {
			replykey = null;
		}
		var vueinst = new Vue({
			el: "#userContentEditor",
			render: function(createElement) {
				return createElement(UserContentEditor, {
				props: {
					tabs: tabs,
					project: project,
					contentkey: key,
					replycontentkey: replykey
				}
			})},
		});
	}
	if($("#userContentLibLoader").length) {
		var libs = $("#userContentLibLoader").attr("data-libs").split(",");
		var vueinst = new Vue({
			el: "#userContentLibLoader",
			render: function(createElement) {
				return createElement(UserContentLibLoader, {
				props: {
					libs: libs
				}
			})},
		});
	}
	if($(".naviDots, .oldNaviDots").length) {
		$(".naviDots, .oldNaviDots").each(function() {
			var el = this;
			var project = $(el).attr("data-project");
			var type = $(el).attr("data-type");
			var key = $(el).attr("data-key");
			var actions = $(el).attr("data-actions").split(",");
			if (project && type && key) {
				var vueinst = new Vue({
					el: el,
					render: function(createElement) {
						return createElement(UserContentEditPanel, {
						props: {
							project: project,
							contenttype: type,
							contentkey: key,
							contentactions: actions
						}
					})},
				});
			}
		});
	}
	if($(".profileAvatar").length) {
		$(".profileAvatar").each(function() {
			var el = this;
			var image = $(el).attr("data-image");
			var vueinst = new Vue({
				el: el,
				render: function(createElement) {
					return createElement(ProfileAvatar, {
					props: {
						image: image
					}
				})},
			});
		});
	}
	if($(".profileSmallAvatar").length) {
		$(".profileSmallAvatar").each(function() {
			var el = this;
			var image = $(el).attr("data-image");
			var vueinst = new Vue({
				el: el,
				render: function(createElement) {
					return createElement(ProfileSmallAvatar, {
					props: {
						image: image
					}
				})},
			});
		});
	}
	if($("#profileAvatarEditor").length) {
		console.log('found profileAvatarEditor');
		var profileId = $("#profileAvatarEditor").attr("data-profile");
		var image = $("#profileAvatarEditor").attr("data-image");
		var vueinst = new Vue({
			el: "#profileAvatarEditor",
			render: function(createElement) {
				return createElement(ProfileAvatarEditor, {
				props: {
					profileId: profileId,
					image: image
				}
			})},
		});
	}
	if($(".profileBanner").length) {
		$(".profileBanner").each(function() {
			var el = this;
			var image = $(el).attr("data-image");
			var vueinst = new Vue({
				el: el,
				render: function(createElement) {
					return createElement(ProfileBanner, {
					props: {
						image: image
					}
				})},
			});
		});
	}
	if($("#profileBannerEditor").length) {
		console.log('found profileBannerEditor');
		var profileId = $("#profileBannerEditor").attr("data-profile");
		var image = $("#profileBannerEditor").attr("data-image");
		var vueinst = new Vue({
			el: "#profileBannerEditor",
			render: function(createElement) {
				return createElement(ProfileBannerEditor, {
				props: {
					profileId: profileId,
					image: image
				}
			})},
		});
	}
	if($(".profileInfo").length) {
		$(".profileInfo").each(function() {
			var el = this;
			var info = $(el).attr("data-info");
			var vueinst = new Vue({
				el: el,
				render: function(createElement) {
					return createElement(ProfileInfo, {
					props: {
						info: info
					}
				})},
			});
		});
	}
	if($(".profileUsername").length) {
		$(".profileUsername").each(function() {
			var el = this;
			var username = $(el).attr("data-username");
			var vueinst = new Vue({
				el: el,
				render: function(createElement) {
					return createElement(ProfileUsername, {
					props: {
						username: username
					}
				})},
			});
		});
	}
	if($(".profilePlatform").length) {
		$(".profilePlatform").each(function() {
			var el = this;
			var platform = $(el).attr("data-platform");
			var propertyKey = $(el).attr("data-key");
			var url = $(el).attr("data-url");
			var vueinst = new Vue({
				el: el,
				render: function(createElement) {
					return createElement(ProfilePlatform, {
					props: {
						platform: platform,
						propertyKey: propertyKey,
						url: url
					}
				})},
			});
		});
	}
	if($(".profileSurveyEditor").length) {
		$(".profileSurveyEditor").each(function() {
			console.log('found profileBannerEditor');
			var el = this;
			var profileId = $(el).attr("data-profile");
			var survey = JSON.parse($(el).attr("data-survey"));
			var surveydata = JSON.parse($(el).attr("data-surveydata"));
			var vueinst = new Vue({
				el: el,
				render: function(createElement) {
					return createElement(ProfileSurveyEditor, {
					props: {
						profileId: profileId,
						survey: survey,
						surveydata: surveydata
					}
				})},
			});
		});
	}
	if($(".profileCompletion").length) {
		$(".profileCompletion").each(function() {
			var el = this;
			var completion = $(el).attr("data-completion");
			var vueinst = new Vue({
				el: el,
				render: function(createElement) {
					return createElement(ProfileCompletion, {
					props: {
						completion: completion
					}
				})},
			});
		});
	}
	if($(".profileDeleter").length) {
		$(".profileDeleter").each(function() {
			console.log('found profileDeleter');
			var el = this;
			var profileId = $(el).attr("data-profile");
			var vueinst = new Vue({
				el: el,
				render: function(createElement) {
					return createElement(ProfileDeleter, {
					props: {
						profileId: profileId
					}
				})}
			});
		});
	}
	if($(".smallProfileNavigation").length) {
		$(".smallProfileNavigation").each(function() {
			console.log('found smallProfileNavigation');
//			console.log(this.innerHTML);
			var el = this;
			var profileId = $(el).attr("data-profile");
			var vueinst = new Vue({
				el: el,
				render: function(createElement) {
					return createElement(
						SmallProfileNavigation, 
						{
							props: {
								profileId: profileId
							},
							domProps: {
								innerHTML: el.innerHTML
							}
						})
				}
			});
		});
	}
	if($(".teaserCountdown").length) {
		$(".teaserCountdown").each(function() {
			var el = this;
			var date = $(el).attr("data-date");
			var vueinst = new Vue({
				el: el,
				render: function(createElement) {
					return createElement(
						TeaserCountdown, 
						{
							props: {
								date: date
							}
						})
				}
			});
		});
	}
	if($("#myFinishedProjects").length) {
		var vueinst = new Vue({
			el: "#myFinishedProjects",
			data: {
				elements: [],
				hasMore: false
			},
			created: function() {
				this.getElements(this);
			},
			render: function(createElement) {
				return createElement(MyFinishedProjectsList, {
				props: {
					elements: this.elements,
					hasMore: this.hasMore
				}})},
			methods: {
				getElementHtml: function(item) {
					jQuery.ajax ({
						url: '/getMyProjectsElement/finished',
						type: 'POST',
						data: JSON.stringify(item),
						contentType: "application/json; charset=utf-8",
						success: function(data) {
							item.html = data;
						},
						error: function() {console.log("error while loading element");}
					});
				},
				initElement: function(item, index) {
					item.html = '';
					this.getElementHtml(item);
				},
				getElements: function(caller) {
					jQuery.ajax ({
						url: '/getFinishedProjectsElements/0',
						type: 'POST',
						dataType: "json",
						data: "",
					    contentType: "application/json; charset=utf-8",
						success: function(data) {
							var result = data;
							result.elements.forEach(caller.initElement);
							caller.elements = result.elements;
							caller.hasMore = result.hasMore;
							caller.$children[0].onElementsLoaded();
						},
						error: function() {console.log("error while loading elements");}
					});
				}
			}
		});
	}
	
	if($(".countdown").length) {
		$(".countdown").each(function() {
			var el = this;
			var date = $(el).attr("data-date");
			var vueinst = new Vue({
				el: el,
				render: function(createElement) {
					return createElement(
						Countdown, 
						{
							props: {
								date: date
							}
						})
				}
			});
		});
	}
}




// WEBPACK FOOTER //
// ./src/js/vue-inst-common.js